import React from 'react';

interface MaturityBadgeProps {
  level: string;
  label: string;
  large?: boolean;
}

const LEVEL_CONFIG: Record<string, { bg: string; text: string; border: string }> = {
  L1: { bg: 'bg-red-50',    text: 'text-red-700',    border: 'border-red-200'    },
  L2: { bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200' },
  L3: { bg: 'bg-yellow-50', text: 'text-yellow-700', border: 'border-yellow-200' },
  L4: { bg: 'bg-blue-50',   text: 'text-blue-700',   border: 'border-blue-200'   },
  L5: { bg: 'bg-green-50',  text: 'text-green-700',  border: 'border-green-200'  },
};

export const MaturityBadge: React.FC<MaturityBadgeProps> = ({ level, label, large = false }) => {
  const cfg = LEVEL_CONFIG[level] || LEVEL_CONFIG['L1'];
  return (
    <div className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg border ${cfg.bg} ${cfg.text} ${cfg.border}`}>
      <span className={`font-black ${large ? 'text-3xl' : 'text-lg'}`}>{level}</span>
      <div>
        <p className={`font-semibold ${large ? 'text-base' : 'text-sm'}`}>{label}</p>
        {large && <p className="text-xs opacity-70">Maturity Level</p>}
      </div>
    </div>
  );
};
